import { productNeedsNameResolve } from '../constants/pricingTierConfig';
import { getProductService } from './products';
import { axiosInstance } from './instance';

const parseTierIdFromResponse = (data) => {
    if (!data) return null;
    const nested = data.response;
    if (nested && typeof nested === 'object' && nested.id) return nested.id;
    if (data.id) return data.id;
    if (typeof nested === 'string') return nested;
    return null;
};

export const getPricingTiersService = (storeId) => {
    return axiosInstance.get(`/stores/${storeId}/pricing-tiers`);
};

export const getPricingTierService = (storeId, tierGroupId) => {
    return axiosInstance.get(`/stores/${storeId}/pricing-tiers/${tierGroupId}`);
};

export const createPricingTierService = (storeId, data) => {
    return axiosInstance.post(`/stores/${storeId}/pricing-tiers`, data);
};

export const updatePricingTierService = (storeId, tierGroupId, data) => {
    return axiosInstance.put(`/stores/${storeId}/pricing-tiers/${tierGroupId}`, data);
};

export const setPricingTierTargetsService = (storeId, tierGroupId, data) => {
    return axiosInstance.put(`/stores/${storeId}/pricing-tiers/${tierGroupId}/targets`, data);
};

export const deletePricingTierService = (storeId, tierGroupId) => {
    return axiosInstance.delete(`/stores/${storeId}/pricing-tiers/${tierGroupId}`);
};

/** Completa nombre, SKU e imagen de productos cuando el API solo devuelve IDs en targets. */
export const enrichTierProductTargets = async (storeId, products = []) => {
    if (!storeId || !Array.isArray(products) || products.length === 0) {
        return products;
    }

    return Promise.all(
        products.map(async (product) => {
            if (!productNeedsNameResolve(product)) {
                return product;
            }
            try {
                const { data } = await getProductService(storeId, product.id);
                return {
                    ...product,
                    name: data?.name || product.name || 'Producto sin nombre',
                    sku: data?.sku || product.sku,
                    picture_url:
                        data?.picture_url ||
                        data?.images?.[0]?.url ||
                        product.picture_url,
                    images: data?.images || product.images,
                };
            } catch {
                return {
                    ...product,
                    name: product.sku ? `SKU ${product.sku}` : 'Producto sin nombre',
                };
            }
        })
    );
};

export { parseTierIdFromResponse };
